import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    flex: 1,
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: "16px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const OptimiseResultsModalActions = ({
  driverEdit,
  onOkClicked,
  onClickClose,
}) => {
  const styles = useStyles();

  return !driverEdit ? (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onOkClicked}
      >
        Ok
      </Button>
    </View>
  ) : (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onOkClicked}
      >
        Confirm
      </Button>
      <Button
        className={styles.yellow}
        variant={"contained"}
        onClick={onClickClose}
      >
        Back To Driver Details
      </Button>
    </View>
  );
};
